export const TransportConstant = {
    operating_transport: {
        id: 'OPERATING_TRANSPORT',
        url: '/operating-transport/',
        title: 'Operating Transport Management',
        favoriteCode: 'OPERATINGTRANSPORT'
    },
    ancillaries_and_services : {
        id: 'ANCILLARIES_AND_SERVICES',
        url: '/ancillaries-and-services/',
        title: 'Ancillaries and Services'
    },
    pax_reaccom: {
        id: 'PAX_REACCOM',
        url: '/pax-reaccom/',
        title: 'Passenger Reaccommodation'
    },    
    categories: {
        id: 'CATEGORIES',
        title: 'Operating Transport Management'
    }
}

export function getTransportConstantByUrl(url: string): any {
    let foundKey = Object.keys(TransportConstant).find(key => TransportConstant[key].url == url);
    if (!foundKey) {
        return null;
    }
    return TransportConstant[foundKey];
}

export function getTransportConstantById(id: string): any {
    let foundKey = Object.keys(TransportConstant).find(key => TransportConstant[key].id == id);
    if (!foundKey) {
        return null;
    }
    return TransportConstant[foundKey];
}

export function getTransportConstantByFavoriteCode(code: string): any {
    let foundKey = Object.keys(TransportConstant).find(key => TransportConstant[key].favoriteCode == code);
    if (!foundKey) {
        return null;
    }
    return TransportConstant[foundKey];
}